import { Paragraph, RangeSlider } from '@finviz/website'
import React from 'react'

interface RangeInputProps {
  label?: string
  value: number
  min?: number
  max?: number
  step?: number
  onChange: (value: number) => void
}

export function RangeInput({ label = 'Range', value, min = 1, max = 10, step = 1, onChange }: RangeInputProps) {
  const handleRangeChange = React.useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      onChange(Number(ev.currentTarget.value))
    },
    [onChange]
  )

  return (
    <RangeSlider
      label={label}
      min={min}
      max={max}
      step={step}
      rightContent={
        <Paragraph as="div" size="small" className="text-right tabular-nums text-gray-900 dark:text-white">
          {value}
        </Paragraph>
      }
      onChange={handleRangeChange}
      value={value}
      data-testid="chart-modal-range-slider"
    />
  )
}
